import { render, staticRenderFns } from "./AttributeChart.vue?vue&type=template&id=77dfe582&scoped=true"
import script from "./AttributeChart.vue?vue&type=script&lang=js"
export * from "./AttributeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dfe582",
  null
  
)

export default component.exports